import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ShareAltOutlined } from '@ant-design/icons';
import IconButton from 'components/IconButton';
import { useState } from 'react';
import { txt } from 'libs/i18n';
import SharedBadge from 'components/SharedBadge';
import { useComputed, useSignals } from '@preact/signals-react/runtime';
import ProjectShareDialog from 'components/ProjectShareDialog';
import styles from './style.module.less';
import { useEditorContext } from '../../contexts/projectSignal';
const ShareSection = ({ onProjectUpdated }) => {
    const { projectSignal } = useEditorContext();
    useSignals();
    const projectShareCount = useComputed(() => projectSignal.value.shareCount).value;
    const [projectSharingVisible, setProjectSharingVisible] = useState(false);
    const handleSharingClosed = (updatedProjects) => {
        setProjectSharingVisible(false);
        if (updatedProjects > 0) {
            void onProjectUpdated();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { id: "shareID", className: styles.shareIcon, tooltip: txt('share'), onClick: () => setProjectSharingVisible(true), children: _jsx(ShareAltOutlined, {}) }), projectShareCount > 1 && (_jsx(SharedBadge, { project: projectSignal.peek(), onRefetch: onProjectUpdated })), _jsx(ProjectShareDialog, { projectsToShare: [projectSignal.peek()], onClose: handleSharingClosed, modalVisible: projectSharingVisible })] }));
};
export default ShareSection;
